import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/pages/Home";
import MissionStatement from "./components/pages/MissionStatement";
import Team from "./components/pages/MeetTheTeam";
import "./App.css";

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/MissionStatement" component={MissionStatement} />
          <Route path="/MeetTheTeam" component={Team} />{" "}
        </Switch>
      </Router>
    </>
  );
}

export default App;
